export default {
  CREDIT_ACTIVITY_LIST_REQUEST: 'APP/CREDIT_ACTIVITY/CREDIT_ACTIVITY_LIST_REQUEST',
  CREDIT_ACTIVITY_LIST_SUCCESS: 'APP/CREDIT_ACTIVITY/CREDIT_ACTIVITY_LIST_SUCCESS',
  CREDIT_ACTIVITY_LIST_ERROR: 'APP/CREDIT_ACTIVITY/CREDIT_ACTIVITY_LIST_ERROR',
};
